import './Component_Confirmation_Popup.css';
import Icons_Repository from '../Icons/Icons_Repository';
import { bookInterviewSlot } from '../Requests/Book_Slots';
import { useState, useEffect, JSX } from 'react';
import { createInvitesForInterviewers } from '../Requests/Create_Invites';
import type { SelectedSlotWithContext } from '../Pages/Candidate_Page1';
import { clearPairingsCache, getInterviewPairings } from '../Requests/Get_Interview_Pairings';
import { rescheduleInterviewSlot, rescheduleInterviewSlotExp, sendRescheduleEmail } from '../Requests/Reschedule_Slot';
import { getInterviewPairingsExp } from '../Requests/Get_Interview_Pairings_Exp';
import { bookInterviewSlotExp } from '../Requests/Book_Slots_Exp';
import { bookInterviewSlotPanel } from '../Requests/Book_Slots_Panel';
import { rescheduleInterviewSlotPanel, sendPanelRescheduleEmail } from '../Requests/Reschedule_Slot_Panel';
import { getInterviewPairingsPanel } from '../Requests/Get_Interview_Pairings_Panel';


interface ConfirmationPopupProps {
  setSelectedPage: (page: string) => void;
  setShowConfirmationPopup: (show: boolean) => void;
  slot: SelectedSlotWithContext;
  candidateEmail: string;
  refreshPairings: () => Promise<void>;
  setSelectedSlot: (slot: SelectedSlotWithContext | null) => void;
  rescheduleClicked: boolean;
  setIsRescheduledClicked: (val: boolean) => void;
  isExperienced: boolean;
  isCampus: boolean;
  isPanel: boolean;
  reschedulingReason: string;
  setReschedulingReason: (reason: string) => void;
  setCandidateSlotAlreadyBooked: (show: boolean) => void;
  allStagesBooked?: boolean;
  currentStage?: string;

}

function Component_Confirmation_Popup({
  setSelectedPage,
  setShowConfirmationPopup,
  slot,
  candidateEmail,
  refreshPairings,
  setSelectedSlot,
  rescheduleClicked,
  setIsRescheduledClicked,
  isExperienced,
  isCampus,
  isPanel,
  reschedulingReason,
  setReschedulingReason,
  setCandidateSlotAlreadyBooked,
  allStagesBooked = false,
  currentStage
}: ConfirmationPopupProps) {

  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // console.log(browserTimeZone);
  const [submitting, setSubmitting] = useState(false);
  const [emailPayload, setEmailPayload] = useState<any>(null);
  console.log(isExperienced, isCampus, reschedulingReason);
  const getAbbreviation = () => {
    try {
      // Get abbreviation via Intl first
      const abbr = new Date().toLocaleTimeString('en-us', {
        timeZone: browserTimeZone,
        timeZoneName: 'short',
      }).split(' ').pop();

      // If it's already a short abbreviation (3–4 uppercase letters), use it
      if (abbr && /^[A-Z]{2,4}$/.test(abbr)) {
        return abbr;
      }

      // Otherwise, map common ones manually
      const knownZones: Record<string, string> = {
        'Asia/Kolkata': 'IST',
        'Asia/Calcutta': 'IST',
        'America/New_York': 'EST',
        'America/Los_Angeles': 'PST',
        'America/Chicago': 'CST',
        'America/Denver': 'MST',
        'Europe/London': 'GMT',
        'Europe/Paris': 'CET',
        'Europe/Berlin': 'CET',
        'Asia/Dubai': 'GST',
        'Asia/Tokyo': 'JST',
        'Australia/Sydney': 'AEDT',
        'Australia/Melbourne': 'AEDT',
      };

      return knownZones[browserTimeZone] || abbr || browserTimeZone;
    } catch {
      return 'UTC';
    }
  };

  useEffect(() => {
    if (isExperienced) return;
    if (!slot || !slot.pairing) return;
    let interview_round = 0;
    const pairing = slot.pairing;
    // console.log(pairing);
    console.log(slot);
    // Build interviewer slots dynamically
    const interviewer_slots: any[] = [];

    if (pairing.interviewer_1_id && pairing.interviewer_1_name && pairing.interview_1_start_time && pairing.interview_1_end_time) {
      interviewer_slots.push({
        interviewer_email: pairing.interviewer_1_id,
        interviewer_name: pairing.interviewer_1_name,
        start_time: new Date(pairing.interview_1_start_time).toISOString(),
        end_time: new Date(pairing.interview_1_end_time).toISOString(),
        interview_type: pairing.interview_1_type
      });
    }

    if (pairing.interviewer_2_id && pairing.interviewer_2_name && pairing.interview_2_start_time && pairing.interview_2_end_time) {
      interviewer_slots.push({
        interviewer_email: pairing.interviewer_2_id,
        interviewer_name: pairing.interviewer_2_name,
        start_time: new Date(pairing.interview_2_start_time).toISOString(),
        end_time: new Date(pairing.interview_2_end_time).toISOString(),
        interview_type: pairing.interview_2_type
      });
    }

    if (pairing.interviewer_3_id && pairing.interviewer_3_name && pairing.interview_3_start_time && pairing.interview_3_end_time) {
      interviewer_slots.push({
        interviewer_email: pairing.interviewer_3_id,
        interviewer_name: pairing.interviewer_3_name,
        start_time: new Date(pairing.interview_3_start_time).toISOString(),
        end_time: new Date(pairing.interview_3_end_time).toISOString(),
        interview_type: pairing.interview_3_type
      });
    }
    if (pairing.interviewer_1_id) {
      interview_round = 1;
    }
    else if (pairing.interviewer_2_id) {
      interview_round = 2;
    }
    else if (pairing.interviewer_3_id) {
      interview_round = 3;
    }

    // Get the reqid and job title from the slot
    const reqId = slot?.requisition_id || pairing?.requisition_id || 'N/A';
    const jobTitleRaw = slot?.job_title || 'N/A';
    const jobTitle = `${reqId} ${jobTitleRaw}`;

    const email_payload: any = {
      email_type: "interview_invite",
      additional_data: {
        candidate_email: candidateEmail,
        // candidate_name: "Pranav Vyas",
        candidate_name: pairing.candidate_full_name,
        interview_start_time: pairing.start_time,
        interview_end_time: pairing.end_time,
        job_title: jobTitle,
        interview_date: new Date(pairing.start_time)
          .toISOString()
          .split("T")[0], // yyyy-mm-dd
        interview_structure: pairing.interview_structure,
        interviewer_slots,
        recruiter_email: pairing.recruiter_email,
        interview_pairing_id: pairing.interview_pairing_id,
        user_timezone: browserTimeZone,
        campus_hire: isCampus,
        interview_round: interview_round,
        experienced_hire: isExperienced,
        is_rescheduled: rescheduleClicked,
        time_zone: getAbbreviation(),
        ...(rescheduleClicked && { reschedule_reason: reschedulingReason })
      },
    };

    console.log("EMAIL PAYLOAD:", email_payload);
    setEmailPayload(email_payload);
  }, [slot, candidateEmail, rescheduleClicked, reschedulingReason]);


  // console.log(slot , candidateEmail);
  // const toMDY = (ymd?: string) => {
  //     if (!ymd) return '';
  //     const [y, m, d] = ymd.split('-');
  //     return `${m}-${d}-${y}`;
  // };
  const toLongDate = (ymd: string): JSX.Element | string => {
    if (!ymd) return ymd;

    const [year, month, day] = ymd.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const getOrdinalSuffix = (n: number): JSX.Element => {
      let suffix = 'th';
      if (n < 11 || n > 13) {
        switch (n % 10) {
          case 1: suffix = 'st'; break;
          case 2: suffix = 'nd'; break;
          case 3: suffix = 'rd'; break;
        }
      }
      return <>{n}</>;
    };

    const weekday = weekdays[date.getDay()];
    const monthName = months[date.getMonth()];
    const dayWithSuffix = getOrdinalSuffix(date.getDate());

    return (
      <>
        {weekday}, {monthName} {dayWithSuffix}, {year}
      </>
    );
  };

  const dStart = new Date(slot.pairing.start_time);
  const dEnd = new Date(slot.pairing.end_time);
  const dateYMD = dStart.toLocaleDateString('en-CA', { timeZone: browserTimeZone });
  const dayName = dStart.toLocaleDateString('en-GB', { timeZone: browserTimeZone, weekday: 'long' });
  const startStr = dStart.toLocaleTimeString('en-US', {
    timeZone: browserTimeZone, hour: 'numeric', minute: '2-digit', hour12: true
  });
  const endStr = dEnd.toLocaleTimeString('en-US', {
    timeZone: browserTimeZone, hour: 'numeric', minute: '2-digit', hour12: true
  });
  const timeRange = `${startStr} – ${endStr}`;

  // const handleConfirm = async () => 
  // {
  //     console.log(slot);
  //     const pairing = slot.pairing;
  //     const interviewerIds = [
  //         pairing.interviewer_1_id,
  //         pairing.interviewer_2_id,
  //         pairing.interviewer_3_id,
  //     ].filter(Boolean) as string[];

  //     if (!slot.requisition_id || interviewerIds.length === 0) {
  //     console.error('Missing data for booking');
  //     return;
  //     }

  //     try {
  //         setSubmitting(true);

  //         // Step 1: Book the slot
  //         await bookInterviewSlot(candidateEmail, pairing.interview_pairing_id);

  //         // Step 2: Try to send invites, but don’t block flow if it fails
  //         try {
  //             await createInvitesForInterviewers(emailPayload);
  //         } catch (inviteError) {
  //             console.error('⚠️ Failed to create invites or send emails:', inviteError);

  //         }

  //         // Step 3: Always clear cache and navigate
  //         clearPairingsCache();
  //         await refreshPairings();
  //         setSelectedSlot(null); 
  //         setShowConfirmationPopup(false);
  //         setSelectedPage('slot-details');

  //     } catch (e) {
  //         console.error('Booking failed:', e);
  //     } finally {
  //         setSubmitting(false);
  //     }
  // };

  // Pick the row matching the slot just booked instead of blindly pairings[0]
  const findBookedPairing = (pairings?: any[]) => {
    try {
      const targetStart = new Date(slot.pairing.start_time).getTime();
      const match = pairings?.find(p => new Date(p?.start_time).getTime() === targetStart);
      console.log("findBookedPairing:", {
        ids: pairings?.map(p => p?.interview_pairing_id),
        selectedSlotId: slot.pairing.interview_pairing_id,
        matchedId: match?.interview_pairing_id,
      });
      return match ?? pairings?.[0];
    } catch {
      return pairings?.[0];
    }
  };

  const buildEmailPayload = (pairingData: any) => {
    if (!pairingData) return null;

    let interview_round = 0;
    const pairing = pairingData;

    // Build interviewer slots dynamically
    const interviewer_slots: any[] = [];

    if (pairing.interviewer_1_id && pairing.interviewer_1_name && pairing.interview_1_start_time && pairing.interview_1_end_time) {
      interviewer_slots.push({
        interviewer_email: pairing.interviewer_1_id,
        interviewer_name: pairing.interviewer_1_name,
        start_time: new Date(pairing.interview_1_start_time).toISOString(),
        end_time: new Date(pairing.interview_1_end_time).toISOString(),
        interview_type: pairing.interview_1_type
      });
    }

    if (pairing.interviewer_2_id && pairing.interviewer_2_name && pairing.interview_2_start_time && pairing.interview_2_end_time) {
      interviewer_slots.push({
        interviewer_email: pairing.interviewer_2_id,
        interviewer_name: pairing.interviewer_2_name,
        start_time: new Date(pairing.interview_2_start_time).toISOString(),
        end_time: new Date(pairing.interview_2_end_time).toISOString(),
        interview_type: pairing.interview_2_type
      });
    }

    if (pairing.interviewer_3_id && pairing.interviewer_3_name && pairing.interview_3_start_time && pairing.interview_3_end_time) {
      interviewer_slots.push({
        interviewer_email: pairing.interviewer_3_id,
        interviewer_name: pairing.interviewer_3_name,
        start_time: new Date(pairing.interview_3_start_time).toISOString(),
        end_time: new Date(pairing.interview_3_end_time).toISOString(),
        interview_type: pairing.interview_3_type
      });
    }

    if (pairing.interviewer_1_id) {
      interview_round = 1;
    } else if (pairing.interviewer_2_id) {
      interview_round = 2;
    } else if (pairing.interviewer_3_id) {
      interview_round = 3;
    }

    const reqId = slot?.requisition_id || pairing?.requisition_id || 'N/A';
    const jobTitleRaw = slot?.job_title || 'N/A';
    const jobTitle = `${reqId} ${jobTitleRaw}`;

    return {
      email_type: "interview_invite",
      additional_data: {
        candidate_email: candidateEmail,
        candidate_name: pairing.candidate_full_name,
        interview_start_time: pairing.start_time,
        interview_end_time: pairing.end_time,
        job_title: jobTitle,
        interview_date: new Date(pairing.start_time).toISOString().split("T")[0],
        interview_structure: pairing.interview_structure,
        interviewer_slots,
        recruiter_email: pairing.recruiter_email,
        interview_pairing_id: pairing.interview_pairing_id,
        user_timezone: browserTimeZone,
        campus_hire: isCampus,
        interview_round: interview_round,
        experienced_hire: isExperienced,
        is_rescheduled: rescheduleClicked,
        time_zone: getAbbreviation(),
        ...(rescheduleClicked && { reschedule_reason: reschedulingReason })
      },
    };
  };

  const handleConfirm = async () => {
    console.log(slot);
    const pairing = slot.pairing;
    const interviewerIds = [
      pairing.interviewer_1_id,
      pairing.interviewer_2_id,
      pairing.interviewer_3_id,
    ].filter(Boolean) as string[];

    if (!slot.requisition_id || interviewerIds.length === 0) {
      console.error('Missing data for booking');
      return;
    }

    try {
      setSubmitting(true);

      const attemptBooking = async () => {
        try {
          // CRITICAL: Use different API based on candidate type
          if (isPanel) {
            console.log("Calling panel booking API");
            await bookInterviewSlotPanel(pairing.interview_pairing_id);
          } else if (isExperienced) {
            console.log("Calling experienced booking API");
            await bookInterviewSlotExp(candidateEmail, pairing.interview_pairing_id);
          } else {
            console.log("Calling campus booking API");
            await bookInterviewSlot(candidateEmail, pairing.interview_pairing_id);
          }
          return true;
        } catch (err) {
          console.error("Booking failed:", err);
          setShowConfirmationPopup(false);
          setSelectedSlot(null);
          setSelectedPage("calendar");
          setCandidateSlotAlreadyBooked(true);
          return false;
        }
      };

      // CASE 1: Normal booking flow
      // CASE 1: Normal booking flow
      if (!rescheduleClicked) {
        console.log("=== BOOKING FLOW START ===");
        console.log("Booking Slot for pairing:", pairing.interview_pairing_id);
        console.log("Is experienced:", isExperienced);
        console.log("=== BOOKING FLOW END ===");

        const ok = await attemptBooking();
        if (!ok) return;

        if (isPanel) {
          const panelPairing = pairing as any;
          // Panel: send single panel invite with all interviewers in array
          const interviewers = [
            { id: panelPairing.interviewer_1_id, name: panelPairing.interviewer_1_name },
            { id: panelPairing.interviewer_2_id, name: panelPairing.interviewer_2_name },
            { id: panelPairing.interviewer_3_id, name: panelPairing.interviewer_3_name },
            { id: panelPairing.interviewer_4_id, name: panelPairing.interviewer_4_name },
            { id: panelPairing.interviewer_5_id, name: panelPairing.interviewer_5_name },
          ]
            .filter(i => i.id && i.name)
            .map(i => ({ email: i.id!, name: i.name! }));

          const reqId = slot?.requisition_id || pairing?.requisition_id || 'N/A';
          const jobTitleRaw = slot?.job_title || 'N/A';
          const jobTitle = `${reqId} ${jobTitleRaw}`;

          const panelInvitePayload = {
            email_type: "send_panel_interviewer_invites",
            additional_data: {
              candidate_email: candidateEmail,
              candidate_name: pairing.candidate_full_name,
              job_title: jobTitle,
              requisition_id: reqId,
              interviewers,
              start_time: new Date(pairing.start_time).toISOString(),
              end_time: new Date(pairing.end_time).toISOString(),
              interview_type: pairing.interview_1_type,
              recruiter_email: pairing.recruiter_email,
              interview_pairing_id: pairing.interview_pairing_id,
            },
          };

          try {
            console.log("Sending panel interviewer invite:", panelInvitePayload);
            await createInvitesForInterviewers(panelInvitePayload);
          } catch (inviteError) {
            console.error('⚠️ Failed to send panel interviewer invite:', inviteError);
          }

          // Send candidate invite
          const candidateInvitePayload = {
            email_type: "send_exp_candidate_invite",
            additional_data: {
              application_id: pairing.total_interviews,
              is_rescheduled: false,
            },
          };
          try {
            console.log("Sending panel candidate invite:", candidateInvitePayload);
            await createInvitesForInterviewers(candidateInvitePayload);
          } catch (inviteError) {
            console.error('⚠️ Failed to send panel candidate invite:', inviteError);
          }

        } else if (isExperienced) {
          // For experienced: send per-interviewer invite emails
          const interviewerSlotDefs = [
            {
              interviewer_email: pairing.interviewer_1_id,
              interviewer_name: pairing.interviewer_1_name,
              start_time: pairing.interview_1_start_time ? new Date(pairing.interview_1_start_time).toISOString() : null,
              end_time: pairing.interview_1_end_time ? new Date(pairing.interview_1_end_time).toISOString() : null,
              interview_type: pairing.interview_1_type,
            },
            {
              interviewer_email: pairing.interviewer_2_id,
              interviewer_name: pairing.interviewer_2_name,
              start_time: pairing.interview_2_start_time ? new Date(pairing.interview_2_start_time).toISOString() : null,
              end_time: pairing.interview_2_end_time ? new Date(pairing.interview_2_end_time).toISOString() : null,
              interview_type: pairing.interview_2_type,
            },
            {
              interviewer_email: pairing.interviewer_3_id,
              interviewer_name: pairing.interviewer_3_name,
              start_time: pairing.interview_3_start_time ? new Date(pairing.interview_3_start_time).toISOString() : null,
              end_time: pairing.interview_3_end_time ? new Date(pairing.interview_3_end_time).toISOString() : null,
              interview_type: pairing.interview_3_type,
            },
          ].filter(s => s.interviewer_email && s.interviewer_name && s.start_time && s.end_time);

          const reqId = slot?.requisition_id || pairing?.requisition_id || 'N/A';
          const jobTitleRaw = slot?.job_title || 'N/A';
          const jobTitle = `${reqId} ${jobTitleRaw}`;

          // Step 1: Send per-interviewer invite
          for (const interviewerSlot of interviewerSlotDefs) {
            const interviewerInvitePayload = {
              email_type: "send_exp_interviewer_invites",
              additional_data: {
                candidate_email: candidateEmail,
                candidate_name: pairing.candidate_full_name,
                job_title: jobTitle,
                requisition_id: reqId,
                interviewer_email: interviewerSlot.interviewer_email,
                interviewer_name: interviewerSlot.interviewer_name,
                start_time: interviewerSlot.start_time,
                end_time: interviewerSlot.end_time,
                interview_type: interviewerSlot.interview_type,
                recruiter_email: pairing.recruiter_email,
                interview_pairing_id: pairing.interview_pairing_id,
              },
            };
            try {
              console.log("Sending exp interviewer invite:", interviewerInvitePayload);
              await createInvitesForInterviewers(interviewerInvitePayload);
            } catch (inviteError) {
              console.error('⚠️ Failed to send exp interviewer invite:', inviteError);
            }
          }

          // Step 2: Check if all stages are now booked; if yes, send consolidated candidate invite
          const allGroups = await getInterviewPairingsExp(false);
          const allBooked = allGroups?.every(group => group.interview_paired) ?? false;

          if (allBooked) {
            const candidateInvitePayload = {
              email_type: "send_exp_candidate_invite",
              additional_data: {
                application_id: pairing.total_interviews,
                is_rescheduled: false,
              },
            };
            try {
              console.log("All stages booked — sending consolidated candidate invite:", candidateInvitePayload);
              await createInvitesForInterviewers(candidateInvitePayload);
            } catch (inviteError) {
              console.error('⚠️ Failed to send exp candidate invite:', inviteError);
            }
          }

        } else {
          // Campus flow: unchanged
          const data = await getInterviewPairings(candidateEmail, false);
          const updatedPairingData = findBookedPairing(data?.pairings);
          const freshEmailPayload = buildEmailPayload(updatedPairingData);
          try {
            console.log("Sending campus invite email with refreshed payload:", freshEmailPayload);
            await createInvitesForInterviewers(freshEmailPayload);
            console.log("Campus invite email sent successfully");
          } catch (inviteError) {
            console.error('⚠️ Failed to create invites or send emails:', inviteError);
          }
        }
      }

      // CASE 2: Reschedule flow
      else {
        let oldSlot: any = null;
        if (isPanel) {
          const oldData = await getInterviewPairingsPanel(false);
          oldSlot = oldData?.pairings?.[0];
          console.log("Old slot for reschedule (panel):", oldSlot);
        } else if (isExperienced && slot?.submission_group_id) {
          // For experienced: get the old slot for THIS STAGE
          const oldData = await getInterviewPairingsExp(false);
          const currentStageGroup = oldData?.find(group =>
            group.pairings[0]?.submission_group_id === slot.submission_group_id
          );
          oldSlot = currentStageGroup?.pairings?.[0];

          console.log("Old slot for reschedule (experienced):", oldSlot);
        } else {
          // For campus: get the single booked slot
          const oldData = await getInterviewPairings(candidateEmail, false);
          console.log(oldData);
          oldSlot = oldData?.pairings?.[0];
        }

        if (!oldSlot || !oldSlot.interview_pairing_id) {
          console.error("No existing slot found to reschedule.");
          return;
        }

        console.log(reschedulingReason);

        if (isPanel) {
          await rescheduleInterviewSlotPanel(oldSlot.interview_pairing_id, reschedulingReason);
          await sendPanelRescheduleEmail({ pairing: oldSlot, job_title: slot.job_title, requisition_id: slot.requisition_id }, candidateEmail, reschedulingReason);
        } else if (isExperienced) {
          await rescheduleInterviewSlotExp(candidateEmail, oldSlot.interview_pairing_id, reschedulingReason);
          await sendRescheduleEmail(
            {
              pairing: oldSlot,
              job_title: slot.job_title,
              requisition_id: slot.requisition_id,
            },
            candidateEmail,
            reschedulingReason,
            isExperienced,
            isCampus
          );
        } else {
          await rescheduleInterviewSlot(candidateEmail, oldSlot.interview_pairing_id, reschedulingReason);
          await sendRescheduleEmail(
            {
              pairing: oldSlot,
              job_title: slot.job_title,
              requisition_id: slot.requisition_id,
            },
            candidateEmail,
            reschedulingReason,
            isExperienced,
            isCampus
          );
        }
        console.log("Back after rescheduling");



        console.log("Back after sending mail... booking slot after rescheduling");
        const ok = await attemptBooking();
        if (!ok) return;

        // Fetch updated pairing data after rescheduling
        console.log("Fetching refreshed pairing data after rescheduling...");
        let updatedPairingData;

        if (isPanel) {
          // Build interviewers array from the NEW slot (pairing, not oldSlot)
          const panelPairing = pairing as any;
          const interviewers = [
            { id: panelPairing.interviewer_1_id, name: panelPairing.interviewer_1_name },
            { id: panelPairing.interviewer_2_id, name: panelPairing.interviewer_2_name },
            { id: panelPairing.interviewer_3_id, name: panelPairing.interviewer_3_name },
            { id: panelPairing.interviewer_4_id, name: panelPairing.interviewer_4_name },
            { id: panelPairing.interviewer_5_id, name: panelPairing.interviewer_5_name },
          ]
            .filter(i => i.id && i.name)
            .map(i => ({ email: i.id!, name: i.name! }));

          const reqId = slot?.requisition_id || pairing?.requisition_id || 'N/A';
          const jobTitle = `${reqId} ${slot?.job_title || 'N/A'}`;

          // send_panel_interviewer_invites
          const panelInvitePayload = {
            email_type: "send_panel_interviewer_invites",
            additional_data: {
              candidate_email: candidateEmail,
              candidate_name: panelPairing.candidate_full_name,
              job_title: jobTitle,
              requisition_id: reqId,
              interviewers,
              start_time: new Date(panelPairing.start_time).toISOString(),
              end_time: new Date(panelPairing.end_time).toISOString(),
              interview_type: panelPairing.interview_1_type,
              recruiter_email: panelPairing.recruiter_email,
              interview_pairing_id: panelPairing.interview_pairing_id,
            },
          };
          try {
            console.log("Sending panel interviewer invites after reschedule:", panelInvitePayload);
            await createInvitesForInterviewers(panelInvitePayload);
          } catch (inviteError) {
            console.error('⚠️ Failed to send panel interviewer invites after reschedule:', inviteError);
          }

          // send_exp_candidate_invite with is_rescheduled: true
          const candidateInvitePayload = {
            email_type: "send_exp_candidate_invite",
            additional_data: {
              application_id: panelPairing.total_interviews,
              is_rescheduled: true,   // RESCHEDULED = true
            },
          };
          try {
            console.log("Sending panel candidate invite after reschedule:", candidateInvitePayload);
            await createInvitesForInterviewers(candidateInvitePayload);
          } catch (inviteError) {
            console.error('⚠️ Failed to send panel candidate invite after reschedule:', inviteError);
          }

        } else if (isExperienced) {
          //   const allGroups = await getInterviewPairingsExp(false);
          //   // Find the matching group by submission_group_id
          //   const matchingGroup = allGroups?.find(group => 
          //     group.pairings[0]?.submission_group_id === slot.submission_group_id
          //   );
          //   updatedPairingData = matchingGroup?.pairings?.[0];
          // } else {
          //   const data = await getInterviewPairings(candidateEmail, false);
          //   updatedPairingData = data?.pairings?.[0];
          // }

          // if (isExperienced) {
          // For experienced reschedule: send per-interviewer invite, then consolidated candidate invite
          const interviewerSlotDefs = [
            {
              interviewer_email: pairing.interviewer_1_id,
              interviewer_name: pairing.interviewer_1_name,
              start_time: pairing.interview_1_start_time ? new Date(pairing.interview_1_start_time).toISOString() : null,
              end_time: pairing.interview_1_end_time ? new Date(pairing.interview_1_end_time).toISOString() : null,
              interview_type: pairing.interview_1_type,
            },
            {
              interviewer_email: pairing.interviewer_2_id,
              interviewer_name: pairing.interviewer_2_name,
              start_time: pairing.interview_2_start_time ? new Date(pairing.interview_2_start_time).toISOString() : null,
              end_time: pairing.interview_2_end_time ? new Date(pairing.interview_2_end_time).toISOString() : null,
              interview_type: pairing.interview_2_type,
            },
            {
              interviewer_email: pairing.interviewer_3_id,
              interviewer_name: pairing.interviewer_3_name,
              start_time: pairing.interview_3_start_time ? new Date(pairing.interview_3_start_time).toISOString() : null,
              end_time: pairing.interview_3_end_time ? new Date(pairing.interview_3_end_time).toISOString() : null,
              interview_type: pairing.interview_3_type,
            },
          ].filter(s => s.interviewer_email && s.interviewer_name && s.start_time && s.end_time);

          const reqId = slot?.requisition_id || pairing?.requisition_id || 'N/A';
          const jobTitleRaw = slot?.job_title || 'N/A';
          const jobTitle = `${reqId} ${jobTitleRaw}`;

          for (const interviewerSlot of interviewerSlotDefs) {
            const interviewerInvitePayload = {
              email_type: "send_exp_interviewer_invites",
              additional_data: {
                candidate_email: candidateEmail,
                candidate_name: pairing.candidate_full_name,
                job_title: jobTitle,
                requisition_id: reqId,
                interviewer_email: interviewerSlot.interviewer_email,
                interviewer_name: interviewerSlot.interviewer_name,
                start_time: interviewerSlot.start_time,
                end_time: interviewerSlot.end_time,
                interview_type: interviewerSlot.interview_type,
                recruiter_email: pairing.recruiter_email,
                interview_pairing_id: pairing.interview_pairing_id,
              },
            };
            try {
              console.log("Sending exp interviewer invite after reschedule:", interviewerInvitePayload);
              await createInvitesForInterviewers(interviewerInvitePayload);
            } catch (inviteError) {
              console.error("⚠️ Failed to send exp interviewer invite after reschedule:", inviteError);
            }
          }

          // Send consolidated candidate invite after reschedule
          const candidateInvitePayload = {
            email_type: "send_exp_candidate_invite",
            additional_data: {
              application_id: pairing.total_interviews,
              is_rescheduled: true,
            },
          };
          try {
            console.log("Sending consolidated candidate invite after reschedule:", candidateInvitePayload);
            await createInvitesForInterviewers(candidateInvitePayload);
          } catch (inviteError) {
            console.error("⚠️ Failed to send exp candidate invite after reschedule:", inviteError);
          }

        } else {
          // Campus reschedule: fetch fresh data AFTER booking
          const data = await getInterviewPairings(candidateEmail, false);
          const updatedPairingData = findBookedPairing(data?.pairings);
          const freshEmailPayload = buildEmailPayload(updatedPairingData);
          // Also set is_rescheduled: true so the correct email is sent
          if (freshEmailPayload?.additional_data) {
            freshEmailPayload.additional_data.is_rescheduled = true;
          }
          try {
            console.log("Sending campus invite email after reschedule with refreshed payload:", freshEmailPayload);
            await createInvitesForInterviewers(freshEmailPayload);
            console.log("Campus invite email sent successfully after reschedule");
          } catch (inviteError) {
            console.error('⚠️ Failed to create invites after reschedule:', inviteError);
          }
        }

        // CRITICAL: Don't reset rescheduleClicked until AFTER navigation
        // setIsRescheduledClicked(false);  // REMOVE THIS LINE
      }

      // Common cleanup - keep popup open during this entire process
      clearPairingsCache();

      // Common cleanup
      clearPairingsCache();

      if (isPanel) {
        // Panel is always a single stage — go straight to slot details
        await new Promise(resolve => setTimeout(resolve, 500));
        setSelectedSlot(null);
        setShowConfirmationPopup(false);
        setIsRescheduledClicked(false);
        setSelectedPage("slot-details");
        await refreshPairings();

      } else if (isExperienced) {
        // Add a small delay to ensure DB has been updated
        await new Promise(resolve => setTimeout(resolve, 500));

        // Fetch fresh data directly from API
        const updatedData = await getInterviewPairingsExp(false);

        console.log("=== BOOKING CHECK DEBUG ===");
        console.log("Fresh data after booking:", JSON.stringify(updatedData, null, 2));
        console.log("Number of groups:", updatedData?.length);

        if (updatedData) {
          updatedData.forEach((group, idx) => {
            console.log(`Group ${idx}: interview_paired = ${group.interview_paired}, stage = ${group.pairings[0]?.stage}, submission_group_id = ${group.pairings[0]?.submission_group_id}`);
          });
        }

        const allBooked = updatedData?.every(group => group.interview_paired) ?? false;
        console.log("All stages booked?", allBooked);
        console.log("=== END DEBUG ===");

        setSelectedSlot(null);
        setShowConfirmationPopup(false);

        if (!allBooked) {
          console.log("Not all stages booked - staying on calendar");
          setIsRescheduledClicked(false); // Reset here, after all processing
          setSelectedPage("calendar");
          await refreshPairings();
        } else {
          console.log("All stages booked - going to slot details");
          setIsRescheduledClicked(false); // Reset here, after all processing
          setSelectedPage("slot-details");
          await refreshPairings();
        }
      } else {
        // Campus candidates go directly to slot details
        setSelectedSlot(null);
        setShowConfirmationPopup(false);
        setIsRescheduledClicked(false); // Reset here, after all processing
        setSelectedPage("slot-details");
        await refreshPairings();
      }
    } catch (e) {
      console.error("Booking or rescheduling failed:", e);
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <div className="main-popup-container">
      <div className='confirmation-popup-card'>
        <div className='popup-header'></div>
        <div className='confirmation-section'>
          <div className='confirmation-text-container'>
            <div className='confirmation-text'>
              {isExperienced && !allStagesBooked ? (
                <>
                  Are you sure you want to proceed with the selected slot?
                  <div style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
                    You will be able to select slots for other rounds after confirming this one.
                  </div>
                </>
              ) : (
                'Are you sure you want to proceed with the selected slot?'
              )}
            </div>
            <div className='confirmation-text-date'>
              <span>({toLongDate(dateYMD)} at {timeRange} {getAbbreviation()})</span>
            </div>
          </div>
        </div>
        {submitting && (
          <div className='processing-message'>
            Please do not refresh the page while your request is being processed.
          </div>
        )}
        <div className='confirmation-buttons'>
          <button
            className={`confirm-button ${submitting ? 'loading' : ''}`}
            onClick={!submitting ? handleConfirm : undefined}
            disabled={submitting}
          >
            {submitting ? (
              <div className='spinner-processing'>
                <span className="spinner"></span>
                <span>Processing...</span>
              </div>
            ) : (
              rescheduleClicked ? 'Yes, reschedule' : 'Yes, confirm'
            )}
          </button>
          <button
            className='reselect-button'
            onClick={() => {
              setSelectedPage('calendar');
              setShowConfirmationPopup(false);
            }}
            disabled={submitting}
          >
            No, reselect
          </button>
        </div>
      </div>
    </div>
  );
}

export default Component_Confirmation_Popup;